import React from "react";
import { Box, Typography } from "@mui/material";
import DetailForm from "@/templates/PromptTemplate/DetailForm";
import useBossBabyPromptTemplateDetail from "./useBossBabyPromptTemplateDetail";

/**
 * 보스베이비 프롬프트 템플릿 상세/수정 페이지
 *
 * @description 보스베이비 채팅 프롬프트 템플릿을 수정하는 페이지
 * @author Max <sud665@ymjlab.com>
 * @version 1.0.0
 * @since 2025-01-29
 */
export default function BossBabyPromptTemplateDetailPage() {
  const {
    data,
    form,
    loading,
    handleSubmit,
    handleDelete,
    handleCancel,
  } = useBossBabyPromptTemplateDetail();

  return (
    <Box>
      <Typography variant="h4" component="h1" sx={{ mb: 3 }}>
        Edit Boss Baby Prompt Template
      </Typography>
      
      <DetailForm
        data={data}
        form={form}
        loading={loading}
        onSubmit={handleSubmit}
        onDelete={handleDelete}
        onCancel={handleCancel}
      />
    </Box>
  );
}









